var map = {
	"./BUSD.svg": "408e",
	"./GYRO-BUSD.svg": "f316",
	"./GYRO-USDT.svg": "bc78",
	"./GYROUSDD.svg": "6c1b",
	"./USDT.svg": "77de",
	"./arrow-left.svg": "12e3",
	"./buy.svg": "222b",
	"./code.svg": "d7a5",
	"./discord.svg": "1191",
	"./docs.svg": "a4fd",
	"./external-link.svg": "841c",
	"./gyro.svg": "bc0d",
	"./icon-GYRO.svg": "9103",
	"./icon-gGYRO.svg": "3add",
	"./icon-pGYRO.svg": "b401",
	"./icon-sGYRO.svg": "7b29",
	"./icon-unstake.svg": "7cf2",
	"./icon-vGYRO.svg": "f223",
	"./logo-dark.svg": "0825",
	"./logo.svg": "bb69",
	"./setup.svg": "9f61",
	"./telegram.svg": "9a40",
	"./vote.svg": "570d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";